exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "input.FormSubmitHack-5f079877{visibility:hidden;position:absolute}\n", ""]);

// Exports
exports.locals = {
	"FormSubmitHack": "FormSubmitHack-5f079877"
};